import Vue from 'vue';
import Router from 'vue-router';

//A-Z
import Home from '@/module/Home/page/Home.vue';
import Register from '@/module/Register/page/Register.vue';
import Profile from '@/module/Profile/page/Profile.vue';
import EditProfile from '@/module/Profile/page/EditProfile.vue';
import Terms from '@/module/Static/page/Terms.vue';
import AboutUs from '@/module/Static/page/About.vue';
import ContactUs from '@/module/Static/page/Contact.vue';
import CopyPersonal from '@/module/Static/page/CopyPersonal.vue';
import BurnList from '@/module/History/page/BurnListPage.vue';
import EarnList from '@/module/History/page/EarnListPage.vue';
import Line from '@/module/Landing/Page/Line.vue';
import Detail from '@/module/Detail/page/Campaign.vue';
import MarketPlace from '@/module/List/page/MarketPlace.vue';
import MarketPlaceList from '@/module/List/page/MarketPlaceList.vue';
import News from '@/module/List/page/News.vue';
import NewsListPage from '@/module/List/page/NewsListPage.vue';
import Privilege from '@/module/List/page/Privilege.vue';
import PrivilegeList from '@/module/List/page/PrivilegeList.vue';
import Product from '@/module/List/page/Product.vue';
import ProductList from '@/module/List/page/ProductList.vue';

import LuckyWinnerList from '@/module/LuckyWinner/page/LuckyWinnerList.vue';

import InviteFriend from '@/module/GetFriend/page/InviteFriend.vue';
import GetFriend from '@/module/GetFriend/page/GetFriend.vue';

//surprise box
import SurpriseMain from '@/module/SurpriseBox/page/SurpriseMain.vue';
import SurpriseOpenBag from '@/module/SurpriseBox/page/SurpriseOpenBag.vue';
//horoscope
import Horoscope from '@/module/Horoscope/page/Horoscope.vue';

import TestUI from '@/module/TestUI/TestUI.vue';
Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/home',
            name: 'home',
            component: Home
        },
        {
            path: '/register',
            name: 'register',
            component: Register
        },
        {
            path: '/register/:type',
            name: 'register',
            component: Register
        },
        {
            path: '/profile',
            name: 'profile',
            component: Profile,
        },
        {
            path: '/profile/edit',
            name: 'editprofile',
            component: EditProfile,
        },
        {
            path: '/terms',
            name: 'terms',
            component: Terms,
        },
        {
            path: '/aboutus',
            name: 'aboutus',
            component: AboutUs,
        },
        {
            path: '/contactus',
            name: 'contactus',
            component: ContactUs,
        },
        {
            path: '/personal/:page?',
            name: 'copypersonal',
            component: CopyPersonal,
        },
        {
            path: '/history/burn',
            name: 'burnhistory',
            component: BurnList,
        },
        {
            path: '/history/earn',
            name: 'earnhistory',
            component: EarnList,
        },
        {
            path: '/linelogin',
            name: 'landingline',
            component: Line
        },
        {
            path: '/reward/:campaignId',
            name: 'campaigndetail',
            component: Detail
        },
        {
            path: '/marketplace',
            name: 'marketplace',
            component: MarketPlace,
            children: [
                {
                    path: '/marketplace',
                    name: 'marketplacelist',
                    component: MarketPlaceList
                },
                {
                    path: '/marketplace/:campaignId',
                    name: 'marketplacedetail',
                    component: Detail
                }
            ]
        },
        {
            path: '/news',
            name: 'news',
            component: News,
            children: [
                {
                    path: '/news',
                    name: 'newslistpage',
                    component: NewsListPage,
                },
                {
                    path: '/news/:campaignId',
                    name: 'newsdetail',
                    component: Detail
                }
            ]
        },
        {
            path: '/product',
            name: 'product',
            component: Product,
            children: [
                {
                    path: '/product',
                    name: 'productlist',
                    component: ProductList,
                },
                {
                    path: '/product/:campaignId',
                    name: 'productdetail',
                    component: Detail
                }
            ]
        },

        {
            path: '/privilege',
            name: 'privilege',
            component: Privilege,
            children: [
                {
                    path: '/privilege',
                    name: 'privilegelist',
                    component: PrivilegeList
                },
                {
                    path: '/privilege/:campaignId',
                    name: 'privilegedetail',
                    component: Detail
                }
            ]
        },
        {
            path: '/winner/:blobfilename',
            name: 'luckywinnerlist',
            component: LuckyWinnerList
        },
        {
            path: '/invite',
            name: 'invite',
            component: InviteFriend
        },
        {
            path: '/getfriend/:refcode',
            name: 'getfriend',
            component: GetFriend
        },
        {
            path: '/surprisebox',
            name: 'surprise box',
            component: SurpriseMain
        },
        {
            path: '/surprisebox/open',
            name: 'surprise open box',
            component: SurpriseOpenBag
        },
        {
            path: '/horoscope/:campaignId',
            name: 'horoscope campaign',
            component: Horoscope
        },
        {
            path: '/testui',
            name: 'testUI',
            component: TestUI
        },
    ]
})
